<div class="m-3">
    <span *ngFor="let experience of experiences; let i = index">
        <app-experience-collapsible [experience]="experience" [animationDelay]="i*300" [visible]="i===0"></app-experience-collapsible>
    </span>
</div>
